import type { ITableHeaderCellProps } from "../interfaces/ITableCellProps";

export const HeaderCellBlank = ({ displayName }: ITableHeaderCellProps) => {
    return (
        <div className="headerCell-blank">
            <div className="headerCell-wide" />
            <div className="u-flex-row u-bold u-alignCenter">
                <span
                    className="headerCell-text"
                    data-automation="header-cell.text"
                >
                    {displayName}
                </span>
            </div>
        </div>
    );
};

HeaderCellBlank.displayName = "HeaderCellBlank";
